import { Box, Typography, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { authErrorState } from '../../atoms/auth-state';
import logo from '../../assets/logo-black.svg';
import CrispCTAButton from '../crisp-cta-button';

const AuthError = () => {
	const intl = useIntl();
	const { logout } = useAuth0();
	const errorMessage = useRecoilValue(authErrorState);

	const handleLogout = () => {
		logout({ logoutParams: { returnTo: window.location.origin } });
	};

	const handleRetry = () => {
		window.location.reload();
	};

	return (
		<Box
			sx={{
				backgroundColor: '#efefef',
				minHeight: '100vh',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Box
				sx={{
					padding: '48px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					maxWidth: '600px',
				}}
			>
				<img src={logo} style={{ width: '100%', maxWidth: '175px', marginBottom: '24px' }} alt='Nuqlea Logo' />

				<img
					width='64'
					height='64'
					src='https://img.icons8.com/cotton/64/error--v5.png'
					alt='error'
					style={{ marginBottom: '16px' }}
				/>

				<Typography
					sx={{
						textAlign: 'center',
						marginBottom: '16px',
						fontSize: '26px',
						fontWeight: 600,
					}}
				>
					{intl.formatMessage({ id: 'auth_error.title' })}
				</Typography>

				<Typography
					sx={{
						textAlign: 'center',
						fontSize: '16px',
						marginBottom: '8px',
						color: '#666',
					}}
				>
					{intl.formatMessage({ id: 'auth_error.description' })}
				</Typography>

				{errorMessage && (
					<Typography
						sx={{
							textAlign: 'center',
							fontSize: '14px',
							marginBottom: '24px',
							color: '#999',
							fontStyle: 'italic',
						}}
					>
						{errorMessage}
					</Typography>
				)}

				<Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
					<Button
						onClick={handleRetry}
						variant='outlined'
						sx={{
							color: '#000',
							border: '1px solid #000',
							borderRadius: '10px',
							minWidth: '140px',
							'&:hover': {
								background: '#f5f5f5',
								border: '1px solid #000',
							},
						}}
					>
						{intl.formatMessage({ id: 'auth_error.retry' })}
					</Button>

					<Button
						onClick={handleLogout}
						variant='contained'
						sx={{
							background: '#000',
							color: '#FFF',
							border: '1px solid #000',
							borderRadius: '10px',
							minWidth: '140px',
							'&:hover': {
								background: '#333',
							},
						}}
					>
						{intl.formatMessage({ id: 'auth_error.logout' })}
					</Button>
				</Box>

				<CrispCTAButton variant='link' className='mt-6' />
			</Box>
		</Box>
	);
};

export default AuthError;
